const Verified = (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#F2FDEB" />
    <g clipPath="url(#clip0)">
      <path
        d="M23.7525 35.3813C23.7525 35.3813 32.505 31.005 32.505 24.4406V16.7822L23.7525 13.5L15 16.7822L15 24.4406C15 31.005 23.7525 35.3813 23.7525 35.3813Z"
        stroke="#088943"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.25 20.25L22.7812 28.5833L19.5 25.1364"
        stroke="#088943"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(12 12)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default Verified;
